function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.42969 15.2346H22.1916C22.5324 15.2346 22.8313 15.0092 22.9236 14.6819L25.9706 4.01767C26.0361 3.78777 25.9913 3.5408 25.8471 3.34978C25.7027 3.15935 25.4781 3.04688 25.2385 3.04688H6.67119L6.12668 0.59668C6.04932 0.247757 5.73987 0 5.38281 0H0.761719C0.34079 0 0 0.34079 0 0.761719C0 1.18285 0.34079 1.52344 0.761719 1.52344H4.77145L7.52217 13.9014C6.71284 14.2533 6.14453 15.0588 6.14453 15.9963C6.14453 17.2563 7.16968 18.2814 8.42969 18.2814H22.1916C22.6127 18.2814 22.9533 17.9409 22.9533 17.5197C22.9533 17.0988 22.6127 16.758 22.1916 16.758H8.42969C8.01015 16.758 7.66797 16.4166 7.66797 15.9963C7.66797 15.576 8.01015 15.2346 8.42969 15.2346Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.66797 20.5666C7.66797 21.8268 8.69312 22.8517 9.95332 22.8517C11.2133 22.8517 12.2385 21.8268 12.2385 20.5666C12.2385 19.3066 11.2133 18.2814 9.95332 18.2814C8.69312 18.2814 7.66797 19.3066 7.66797 20.5666Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3829 20.5666C18.3829 21.8268 19.4081 22.8517 20.6681 22.8517C21.9283 22.8517 22.9532 21.8268 22.9532 20.5666C22.9532 19.3066 21.9283 18.2814 20.6681 18.2814C19.4081 18.2814 18.3829 19.3066 18.3829 20.5666Z",
  fill: "white"
});

var SvgShoppingCart = function SvgShoppingCart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShoppingCart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shopping-cart.d1e39d9e.svg";
export { ForwardRef as ReactComponent };